import { render, staticRenderFns } from "./ReduceForecastDaysOutput.vue?vue&type=template&id=6cbbb2b8&scoped=true&"
import script from "./ReduceForecastDaysOutput.vue?vue&type=script&lang=ts&"
export * from "./ReduceForecastDaysOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbbb2b8",
  null
  
)

export default component.exports